export const RESOURCES = [
  {
    slug: "stress-and-burnout",
    title: "Stress and Burnout",
    summary:
      "Recognize early warning signs and reset your nervous system before exhaustion takes hold.",
    icon: "Activity",
    points: [
      "Identifying chronic stress vs. healthy pressure",
      "A 3-minute reset technique you can use at your desk",
      "When to ask for a workload conversation with your manager",
      "Building recovery time into your week without guilt",
    ],
    body:
      "Burnout is rarely about one bad week — it builds quietly when demand outpaces recovery for too long. Watch for sleep changes, cynicism, withdrawal from people you usually enjoy, and a feeling of going through the motions. Small interventions matter: short walks between meetings, a real lunch break, and naming what you're feeling out loud to someone safe. If the load is structural, a chaplain can help you think through how to have the conversation with leadership without it costing you.",
  },
  {
    slug: "grief-and-loss",
    title: "Grief and Loss",
    summary:
      "Grief shows up at work, too. Quiet, practical support for moving through hard seasons.",
    icon: "HeartHandshake",
    points: [
      "What to expect in the first 30, 60, and 90 days",
      "Talking to your team about a loss — only if you want to",
      "Anniversary dates, triggers, and giving yourself permission",
      "When grief and depression start to overlap",
    ],
    body:
      "Grief doesn't move in a straight line. You may feel steady for a week, then ambushed by a song in the elevator. That is normal. Many employees find that returning to work helps with structure, while others need flexibility. A confidential conversation can help you decide what to share, with whom, and when. You don't have to carry it alone, and you don't have to perform being okay.",
  },
  {
    slug: "conflict-at-work",
    title: "Conflict at Work",
    summary:
      "Move from reaction to clarity when a coworker, manager, or team dynamic feels off.",
    icon: "Users",
    points: [
      "Separating the issue from the person",
      "Scripts for hard one-on-one conversations",
      "When to involve HR vs. resolve directly",
      "Repairing trust after a heated exchange",
    ],
    body:
      "Most workplace conflict isn't about the surface issue — it's about feeling unseen, disrespected, or unsafe. Before reacting, get clear on what outcome you actually want. A chaplain can serve as a neutral sounding board, separate from HR and from your manager, while you decide your next step. Confidentiality means you can talk it through honestly, including the parts you're not proud of.",
  },
  {
    slug: "family-stress",
    title: "Family Stress",
    summary:
      "Marriage, parenting, caregiving, and the way home life follows you to work.",
    icon: "Home",
    points: [
      "Caring for an aging parent while holding a full-time role",
      "Parenting through a teen's hard season",
      "Marriage strain during high-demand work seasons",
      "Setting boundaries between home and work without guilt",
    ],
    body:
      "When something is hard at home, it follows you into every meeting. You don't have to wait for a crisis to ask for support. Chaplains often walk alongside employees through caregiving fatigue, parenting stress, and marriage strain. The conversation is yours — confidential, no notes shared with your employer, no agenda beyond what you need.",
  },
  {
    slug: "leadership-support",
    title: "Leadership Support",
    summary:
      "The conversations leaders can't have with their team or their boss.",
    icon: "Compass",
    points: [
      "Carrying decisions you can't talk about publicly",
      "Leading a team through change or layoffs",
      "Loneliness at the top — and why it matters",
      "Sustaining your own well-being while caring for others",
    ],
    body:
      "Leaders are expected to be steady for everyone else. That cost adds up. Chaplains regularly meet with executives, owners, and team leads who need a confidential space to think out loud — about a hard call, a team they're worried about, or how they're doing personally. No reporting line. No performance review. Just space to be human.",
  },
  {
    slug: "crisis-support",
    title: "Crisis Support",
    summary:
      "When something serious has happened — at home, on the job, or in the team.",
    icon: "ShieldAlert",
    points: [
      "After a sudden loss in the workplace or family",
      "Critical incidents and team debriefs",
      "Supporting an employee through a personal crisis",
      "Connecting you to additional professional resources when needed",
    ],
    body:
      "If you or someone you love is in immediate danger, call 911 or your local emergency services. For everything short of an emergency — a death in the team, a serious diagnosis, a frightening event at home — a chaplain can show up quickly, listen without flinching, and help you figure out the next right step. You won't be rushed.",
  },
];

export const RESOURCE_BY_SLUG = Object.fromEntries(RESOURCES.map((r) => [r.slug, r]));
